export default {
    sortOrder: {
        ascending: "Asc",
        descending: "Desc"
    },
    status: {
        idle: "idle",
        loading: "loading"
    },
    errorType: {
        pagingParametersChanged: "pagingParametersChanged",
        getItemsFailure: "getItemsFailure",
        invalidPageNumber: "invalidPageNumber"
    }
};
